// extracted by mini-css-extract-plugin
module.exports = {"copyright":"FooterNavigationGroup_copyright__7gQkS","copyrightLinks":"FooterNavigationGroup_copyrightLinks__Nfb64","copyrightText":"FooterNavigationGroup_copyrightText__MBq2L"};